import { render, staticRenderFns } from "./not-saved-ch.vue?vue&type=template&id=7ec59fa5"
import script from "./not-saved-ch.vue?vue&type=script&lang=js"
export * from "./not-saved-ch.vue?vue&type=script&lang=js"
import style0 from "./not-saved-ch.vue?vue&type=style&index=0&id=7ec59fa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports